module.exports = __webpack_public_path__ + "img/en_us.d652e806.png";